import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';

const LogoutTitle = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['bold']};
  font-size: ${40 * Screen.widthRatio}px;
  line-height: ${38 * Screen.widthRatio}px;
  margin-bottom: ${45 * Screen.widthRatio}px;
`;

export default LogoutTitle;
